import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '../../../hooks/store';
import {Config} from '../../../../shared/types';
import {fetchConfig} from '../../../api/config';
import {Status} from '../availability/slice';

export type ConfigState = {
  data: Omit<Config, 'growthbook' | 'commit' | 'branch'>;
  status: Status;
};

const initialState: ConfigState = {
  data: {
    environment: 'dev',
    version: '',
  },
  status: 'idle',
};

export const requestConfig = createAsyncThunk(
  'config/fetch',
  () => {
    const config = fetchConfig();
    return config;
  },
  {
    condition(_, {getState}) {
      const state = getState() as RootState;
      return state.config.status !== 'pending';
    },
  },
);

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(requestConfig.fulfilled, (state, action) => {
      state.data.environment = action.payload.environment;
      state.data.version = action.payload.version;
      state.status = 'fulfilled';
    });
    builder.addCase(requestConfig.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(requestConfig.rejected, (state) => {
      state.status = 'rejected';
    });
  },
});

const selectConfigRootState = (state: RootState) => state.config;

const selectConfigData = (state: RootState) => {
  return selectConfigRootState(state).data;
};

export const selectConfigRequestStatus = (state: RootState) =>
  selectConfigRootState(state).status;

export const selectEnvironment = (state: RootState) => {
  return selectConfigData(state).environment;
};
